import { Model } from 'app/model/backendmodel';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FactoryCacheService {
    public factory: Model.Factory | null;
}
